/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { CreateCompuweighRequest } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class CompuweighMassCreates<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name CreateCompuweigh
   * @request POST:/compuweigh-mass-creates
   * @secure
   */
  createCompuweigh = (data: CreateCompuweighRequest, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/compuweigh-mass-creates`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsCompuweighMassCreates
   * @request OPTIONS:/compuweigh-mass-creates
   */
  optionsCompuweighMassCreates = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/compuweigh-mass-creates`,
      method: 'OPTIONS',
      ...params,
    });
}
